// Vue
import { Vue, Component, Prop, Inject, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { ContentModule } from "../../common/content_module/ContentModule";
import { reaction } from "mobx";
import ModuleWrapper from "../../../components/module_wrapper/ModuleWrapper";
import { Api } from "../../../api";
import { Product } from "../../../common/interfaces/conversionworld/Product";
import { ProductLink } from "../product_list/product_link/ProductLink";
import { FilterModule } from "../filter_module/FilterModule";
import { ProductListVanSolutionModule } from "../product_list/product_list_van_solution_module/ProductListVanSolutionModule";
import { ProductListVanPartnerModule } from "../product_list/product_list_van_partner_module/ProductListVanPartnerModule";
import { Headline } from "../../../components/headline/Headline";
import { BodybuilderList } from "../abh_overview_page_module/bodybuilder_list/BodybuilderList";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ProductLink,
    FilterModule,
    ProductListVanSolutionModule,
    ProductListVanPartnerModule,
    Headline,
    BodybuilderList,
  },
})
export class SearchResultModule extends ModuleBase {
  private activeTab: string = "solution";

  getBackgroundColorFromInstance(instance: object): string {
    return "white";
  }

  get vanSolutionHeadline() {
    return this.instance["bodybuilder_list"]["headline_van_solution"];
  }

  get vanPartnerHeadline() {
    return this.instance["bodybuilder_list"]["headline_van_partner"];
  }

  get bodybuilderListLoadMore() {
    return this.instance["bodybuilder_list"]["load_more"];
  }

  get productListVanSolutionInstance() {
    return {
      mode: "search",
      textModules: [],
      translation: {
        kacheln: "",
        liste: "",
        headline_singular: this.instance["product_van_solution"]["headline"],
        headline_plural: this.instance["product_van_solution"]["headline"],
        loesung_ab_werk:
          this.instance["product_van_solution"]["loesung_ab_werk"],
        compare_product:
          this.instance["product_van_solution"]["compare_product"],
        compare_product_to_many:
          this.instance["product_van_solution"]["compare_product_to_many"],
        load_more: this.instance["product_van_solution"]["load_more"],
      },
    };
  }

  get productListVanPartnerInstance() {
    return {
      mode: "search",
      textModules: [],
      translation: {
        kacheln: "",
        liste: "",
        headline_singular: this.instance["product_van_partner"]["headline"],
        headline_plural: this.instance["product_van_partner"]["headline"],
        compare_product:
          this.instance["product_van_partner"]["compare_product"],
        compare_product_to_many:
          this.instance["product_van_partner"]["compare_product_to_many"],
        load_more: this.instance["product_van_partner"]["load_more"],
      },
    };
  }

  get filterInstance() {
    return {
      mode: "",
      translation: {
        filterButton: this.instance["filter"]["filterButton"],
        compareButton: this.instance["filter"]["compareButton"],
        allSolution: this.instance["filter"]["allSolution"],
        onlyVanSolution: this.instance["filter"]["onlyVanSolution"],
        onlyVanPartner: this.instance["filter"]["onlyVanPartner"],
        resetFilter: this.instance["filter"]["resetFilter"],
        resetAllFilter: this.instance["filter"]["resetAllFilter"],
        headline_filter: this.instance["filter"]["headline_filter"],
        headline_country: this.instance["filter"]["headline_country"],
        headline_branche: this.instance["filter"]["headline_branche"],
        headline_aufbauart: this.instance["filter"]["headline_aufbauart"],
        headline_model: this.instance["filter"]["headline_model"],
        headline_abh: this.instance["filter"]["headline_abh"],
        abh_search_desktop: this.instance["filter"]["abh_search_desktop"],
        abh_search_mobile: this.instance["filter"]["abh_search_mobile"],
        abh_search_van_solution:
          this.instance["filter"]["abh_search_van_solution"],
        show_results: this.instance["filter"]["show_results"],
        count_selected: this.instance["filter"]["count_selected"],
        refine_model_filter: this.instance["filter"]["refine_model_filter"],
        refine_antriebsart: this.instance["filter"]["refine_antriebsart"],
        refine_radstand: this.instance["filter"]["refine_radstand"],
        refine_gesamtgewicht: this.instance["filter"]["refine_gesamtgewicht"],
        refine_dachart: this.instance["filter"]["refine_dachart"],
        refine_kabinenart: this.instance["filter"]["refine_kabinenart"],
      },
      comparision: this.instance["comparision"],
      "comparision-layer": this.instance["comparision-layer"],
    };
  }

  get searchQuery() {
    return this.$store.conversionWorldProductFilter.filter.query;
  }

  public created() {
    this.$store.conversionWorldProductFilter.filter.query = decodeURI(
      this.$store.page.page!.route_parameter["query"]
    );
    if (window.location.hash === "#bodybuilder") {
      this.activeTab = "bodybuilder";
    }
  }

  public activateTab(name, event) {
    event.preventDefault();
    this.activeTab = name;
  }

  public handleCancelQuery() {
    this.$eventBus.$emit("conversion-world-open-search-layer");
  }
}
